import { useCallback, useMemo } from "react";
import { useSearchParams } from "react-router-dom";

import { SectionIds } from "@hd/types/shared/section-ids";
import { useAuthStore } from "../auth.store";
import CompanySelector from "./CompanySelector";

interface PageCompanySelectorProps {
  onChange?: (companyId: number) => void;
  sectionId: SectionIds;
  hasGroup?: boolean;
}

function PageCompanySelector({
  onChange,
  sectionId,
  hasGroup = false,
}: PageCompanySelectorProps) {
  const pageCompanyId = useAuthStore((s) => s.pageCompanyId);

  const changeSelectedCompanyId = useAuthStore((s) => s.setPageCompanyId);

  const [searchParams, setSearchParams] = useSearchParams();

  const companyId = useMemo(() => {
    if (searchParams.get("companyId"))
      return Number(searchParams.get("companyId"));

    if (pageCompanyId) return pageCompanyId;

    return null;
  }, [searchParams, pageCompanyId]);

  // const [companyId, setCompanyId] = useState<number | null>(searchParams.get("companyId") ? Number(searchParams.get("companyId")) : null);

  const onChangeHandler = useCallback(
    (newCompanyId: number | null) => {
      changeSelectedCompanyId(newCompanyId);

      setSearchParams(
        (prev) => {
          const newSearchParams = new URLSearchParams(prev.toString());
          if (newCompanyId) {
            newSearchParams.set("companyId", newCompanyId.toString());
          } else {
            newSearchParams.delete("companyId");
          }
          return newSearchParams;
        },
        { replace: true },
      );

      if (!newCompanyId) return;

      onChange?.(newCompanyId);
    },
    [changeSelectedCompanyId, setSearchParams, onChange],
  );

  // useEffect(() => {
  //   const companyIdParam = searchParams.get("companyId");
  //   if (companyIdParam) {
  //     setCompanyId(Number(companyIdParam));
  //   }
  // }, [searchParams]);

  // useEffect(() => {
  //   if (pageCompanyId !== companyId && companyId == null) {
  //     setCompanyId(pageCompanyId);
  //   }
  // }, [pageCompanyId, companyId]);

  return (
    <CompanySelector
      label="Stai lavorando su"
      sectionId={sectionId}
      hasGroup={hasGroup}
      selectedCompanyChanged={onChangeHandler}
      selectedCompanyId={companyId}
    />
  );
}

export default PageCompanySelector;
